<template>
<div class="progress-bar-container">
  <div v-if="title" class="progress-bar--title">
    {{title}}
  </div>
  <div class="progress-bar" :class="[ {'has-content': !isMini}, advancement ]" >
    <div class="progress-bar--progression" :style="'width: ' + percentage + '%'">
      <span v-if="!isMini">
        {{percentage.toFixed(0)}}
      </span>
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    title: String,
    percentage: Number,
    isMini: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    advancement(){
      if(this.percentage <= 0){
        return "progress-bar-empty"
      }
      else if(this.percentage < 40){
        return "progress-bar-low"
      }else if((this.percentage >= 40) && (this.percentage  <= 59)){
        return "progress-bar-middle1"
      }else if((this.percentage >= 60) && (this.percentage  <= 75)){
        return "progress-bar-middle"
      }else{
        return "progress-bar-high"
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// ProgressBar.vue?44eaa9eb